import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Box, useTheme, useMediaQuery } from '@mui/material'
import { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import MyDurationInput from '../../../components/inputs/MyDurationInput';
import MySelectInput from '../../../components/inputs/MySelectInput';
import MyAutoComplete from '../../../components/inputs/MyAutoCompleteJavier';
import MyRadioGroup from '../../../components/inputs/MyRadioGroup';
import { myApi } from '../../../config/axiosConfig';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useFormikContext } from 'formik';
import Cookies from 'js-cookie';
import { useRef } from 'react';

function CrearEditarColombia({ open, onClose, refresh, carga, isEditing, onUpdate, onCreate }) {

    const [isSaving, setIsSaving] = useState(false);

    const [resetCounter, setResetCounter] = useState(0);
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
        const [datePart, timePart] = formattedDate.split(', ');
        const [month, day, year] = datePart.split('/');
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`;
    
        return formattedDateTime;
    };

    const positiveNumber = (label, gender = 'El') => 
    {
        let verbo = 'es';
        let obligatorio = 'obligatorio';

        switch (gender) {
            case 'El':
                verbo = 'es';
                obligatorio = 'obligatorio';
                break;
            case 'La':
                verbo = 'es';
                obligatorio = 'obligatoria';
                break;
            case 'Los':
                verbo = 'son';
                obligatorio = 'obligatorios';
                break;
            case 'Las':
                verbo = 'son';
                obligatorio = 'obligatorias';
                break;
            default:
                verbo = 'es';
                obligatorio = 'obligatorio';
        }

        return Yup.string()
            .required(`${gender} ${label} ${verbo} ${obligatorio}`)
            .test('is-number', 'Debe ser un número válido', value => {
                if (!value) return false;
                const num = Number(value.toString().replace(/[^0-9.-]/g, ''));
                return !isNaN(num);
            })
            .test('positive', 'Debe ser mayor que 0', value => {
                const num = Number(value.toString().replace(/[^0-9.-]/g, ''));
                return num > 0;
            });
    };
    
    const validationSchema = Yup.object(
    {
        date: Yup.string().required('La fecha es obligatoria'),
        asset: Yup.string().required('La unidad es obligatoria'),

        driver: Yup.string().required('El operador es obligatorio'),
        move_type: Yup.string().required('Escoja si es IMPO o EXPO'),
        //liters: positiveNumber('cantidad LTS', 'La'),
        gallons: positiveNumber('cantidad GLLS', 'La'),
        tank_odometer: positiveNumber('odómetro del tanque', 'El')
    });

    const normalizeAssetType = (assetType) => 
    {
        if (assetType === 'CAJA') return 'CAJA';
        return 'TRACTOR';
    };

    const initialValues = 
    {
        date: carga?.date ? moment(formatDate(carga.date), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
        
        asset: carga?.asset || null,

        asset_type: carga ? normalizeAssetType(carga.asset_type) : '',
        transportline: carga?.transportline || '',
        Asset_trsnport_line: carga?.Asset_trsnport_line || '',

        driver: carga?.driver || '',

        //liters: carga?.liters || '',
        gallons: carga?.gallons || '',

        fuel_dispatcher: carga?.fuel_dispatcher || Cookies.get('ebt_nombre'),
        move_type: carga?.move_type || '',

        tank_odometer: carga?.tank_odometer || '',

        brand: carga?.brand || '',

        usuario: Cookies.get('ebt_nombre'),

        order: carga?.order || ''
    };

    const norm = (x) =>
    String(x ?? '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, '')
        .replace(/[-_]/g, '');
    
    const resolveAssetType = async (values) => 
    {
        if (values.asset_type === 'CAJA') 
        {
            return 'CAJA';
        }

        if (values.asset_type === 'TRACTOR') 
        {
            /* const tractorInfo = tractorCatalog.find(
                t => String(t.value).trim() === String(values.asset).trim()
            ); */
            const tractorInfo = tractorCatalog.find(t => norm(t.value) === norm(values.asset));

/*             if (!tractorInfo) 
                return 'TRACTOR'; */

            if(!tractorInfo) 
            {
                Swal.fire({
                    target: document.getElementById('dialog1'),
                    icon: 'warning',
                    title: 'Catálogo incompleto',
                    text: 'No encontré la unidad en el catálogo. Espera a que termine de cargar y vuelve a intentar.'
                });
                throw new Error('No tractorInfo yet');
            }

            if (tractorInfo.company === 'TEDEL') 
            {
                return 'BPMX';
            }

            if (tractorInfo.company === 'EBT') 
            {
                try 
                {
                    const statuses = ['A', 'I', 'S'];

                    const requests = statuses.map(status =>
                    axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        {
                        company: 'EBT',
                        status,
                        tractor: String(values.asset).trim(),
                        },
                        { timeout: 15000 }
                    )
                    );

                    const responses = await Promise.allSettled(requests);

                    const data = responses
                        .filter(r => r.status === 'fulfilled')
                        .flatMap(r => r.value.data || []);

                    const unique = Array.from(
                        new Map(data.map(item => [item.tractor, item])).values()
                    );

                    const typeOf = unique?.[0]?.type_of;
                    if (!typeOf) 
                    {
                        Swal.fire({ 
                            target: document.getElementById('dialog1'),
                            icon: 'warning', 
                            title: 'Sin tipo', 
                            text: 'McLeod no devolvió type_of para esa unidad.' 
                        });
                        throw new Error('No type_of');
                    }
                    return typeOf;
                }
                catch (e) 
                {
                    Swal.fire({ 
                        target: document.getElementById('dialog1'),
                        icon: 'warning', 
                        title: 'No se pudo resolver el tipo', 
                        text: 'Intenta de nuevo.' 
                    });
                    throw e;
                }
            }
        }

        //return values.asset_type;
    };

    const handleSubmit = async (values, { resetForm }) => 
    {

        //const resolvedAssetType = await resolveAssetType(values);

        let resolvedAssetType;
        try 
        {
            resolvedAssetType = await resolveAssetType(values);
        } 
        catch 
        {
            return;
        }

        const catalog =
            values.asset_type === 'TRACTOR'
                ? tractorCatalog
                : values.asset_type === 'CAJA'
                ? cajaCatalog
                : [];

        //const assetInfo = catalog.find(a => String(a.value).trim() === String(values.asset).trim());
        const assetInfo = catalog.find(a => norm(a.value) === norm(values.asset));
        const company = assetInfo?.company || 'EXTERNO';

        const marca = assetInfo?.marca || '';

        const formData = new FormData();

        Object.entries(values).forEach(([k, v]) => 
        {
            formData.append(k, v);
        });

        const computedFields = {
            asset_type: resolvedAssetType,
            transportline: company,
            Asset_trsnport_line: company,
            brand: marca
        };

        Object.entries(computedFields).forEach(([k, v]) => {
            formData.set(k, v);
        });

        setIsSaving(true);
        try 
        {
            if (isEditing) 
            {
                let responseEditar = await myApi.put(`/cargasFuel/editarColombia/${carga.id}`, formData);

                if(responseEditar.data.success)
                {
                    onUpdate(responseEditar.data.data);
                    Swal.fire({
                        target: document.getElementById('dialog1'),
                        icon: 'success',
                        title: 'Carga editada',
                    });
                    setResetCounter(c => c + 1);
                    onClose();
                }
                else
                {
                    Swal.fire({
                        target: document.getElementById('dialog1'),
                        icon: 'error',
                        title: 'Error al editar carga',
                        text: responseEditar.data.data || 'Ocurrió un error desconocido',
                    });

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                let responseCrear = await myApi.post('/cargasFuel/crearColombia', formData);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        target: document.getElementById('dialog1'),
                        icon: 'success',
                        title: 'Carga creada',
                    });
                    setResetCounter(c => c + 1);
                    refresh();
                    onClose();
                }
                else
                {
                    Swal.fire({
                        target: document.getElementById('dialog1'),
                        icon: 'error',
                        title: 'Error al crear carga',
                        text: responseCrear.data.data || 'Ocurrió un error desconocido',
                    });

                    console.error('Error de API:', responseCrear.data);
                }
            }
            onClose();
        } 
        catch (error) 
        {
            console.error('Error saving fuel up:', error);
        }
        finally { setIsSaving(false); }
    };

    const fields = 
    [
        { 
            name: 'date', 
            label: 'FECHA', 
            type: 'datetime', 
            colSpan: 1 
        },
        {
            name: 'asset_type',
            label: 'TIPO DE UNIDAD',
            type: 'select',
            colSpan: 1,
            options: 
            [
                { 
                    value: 'TRACTOR', 
                    label: 'TRACTOR' },
                { 
                    value: 'CAJA', 
                    label: 'CAJA' 
                },
            ],
        },
        {
            name: 'asset',
            label: 'UNIDAD',
            type: 'autocomplete',
            colSpan: 1,
        },
        {
            name: 'driver',
            label: 'OPERADOR',
            type: 'autocomplete',
            colSpan: 3,
        },

        //{ name: 'liters', label: 'CANTIDAD LTS', type: 'number', colSpan: 2 },
        { name: 'gallons', label: 'CANTIDAD GLLS', type: 'number', colSpan: 2 },
        {
            name: 'move_type',
            label: 'IMPO / EXPO',
            type: 'radio',
            colSpan: 1,
            options: [
                { value: 'Importación', label: 'IMPO' },
                { value: 'Exportación', label: 'EXPO' },
            ],
        },
        { name: 'order', label: 'ORDEN', type: 'text', colSpan: 1 },

        { name: 'tank_odometer', label: 'ODOMETRO TANQUE', type: 'number', colSpan: 1 },
    ];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

        const [tractorCatalog, setTractorCatalog] = useState([]);

    const companies = ['EBT', 'TEDEL'];
    const statuses = ['A', 'I', 'S'];

    useEffect(() => 
    {
        const fetchAllTractors = async () => 
        {
            try 
            {
                const requests = [];

                companies.forEach((company) => {
                    statuses.forEach((status) => {
                    requests.push(
                        axios.post(
                        'https://apigeneral.ebtapps.com/general/api/mcleod/trucks/',
                        {
                            company,
                            status,
                            tractor: null
                        },
                        { timeout: 15000 }
                        )
                    );
                    });
                });

/*                 const responses = await Promise.all(requests);

                const allData = responses.flatMap((res) => res.data); */

                const responses = await Promise.allSettled(requests);

                const ok = responses
                    .filter(r => r.status === 'fulfilled')
                    .map(r => r.value);

                const allData = ok.flatMap(res => res.data);

/*                 const unique = Array.from(
                    new Map(allData.map((item) => [item.tractor, item])).values()
                ); */

                const key = (x) => String(x ?? '').trim();
                const unique = Array.from(
                    new Map(
                    allData
                        .filter(item => item?.tractor != null)
                        .map(item => [key(item.tractor), item])
                    ).values()
                );

                const catalog = unique.map((item) => ({
                    value: String(item.tractor).trim(),
                    label: String(item.tractor).trim(),
                    company: item.company,
                    marca: item.make
                }));

                setTractorCatalog(catalog);
            } 
            catch (error) 
            {
                console.error('Error cargando tractores:', error);
            }
        };

        fetchAllTractors();
    }, []);

    const [cajaCatalog, setCajaCatalog] = useState([]);

    useEffect(() => 
    {
        const fetchAllTrailers = async () => 
        {
            try 
            {
                const requests = [];

                companies.forEach((company) => {
                    statuses.forEach((status) => {
                        requests.push(
                            axios.post(
                                'https://apigeneral.ebtapps.com/general/api/mcleod/trailers',
                                {
                                    company,
                                    status,
                                    trailer: null
                                }
                            )
                        );
                    });
                });

                const responses = await Promise.all(requests);

                const allData = responses.flatMap((res) => res.data);

                const uniqueTrailers = Array.from(
                    new Map(allData.map((item) => [item.trailer, item])).values()
                );

                const catalog = uniqueTrailers.map((item) => ({
                    value: String(item.trailer).trim(),
                    label: String(item.trailer).trim(),
                    company: item.company,
                    marca: item.make
                }));

                setCajaCatalog(catalog);
            } 
            catch (error) 
            {
                console.error('Error cargando trailers:', error);
            }
        };

        fetchAllTrailers();
    }, []);

    const AssetTypeWatcher = () => 
    {
        const { values, setFieldValue } = useFormikContext();
        const firstLoad = useRef(true);

        useEffect(() => 
        {
            if (firstLoad.current) 
            {
                firstLoad.current = false;
                return;
            }

            setFieldValue('asset', '');
            setFieldValue('truck_odometer', '');
            setFieldValue('trailer_engine_hrs', '');
        }, [values.asset_type]);

        return null;
    };

    const [operadores, setOperadores] = useState([]);

    const findOperadores = async () => {
        try {
            const response = await myApi.get('/fuel_report/getOperadores');

            let operadores = [];
            if (response.data.data && response.data.data.length > 0) {
                response.data.data.forEach(operador => {
                    operadores.push({ value: operador.nombre_completo, label: operador.nombre_completo });
                });
            }
            setOperadores(operadores.length > 0 ? operadores : []); 

        } catch (error) {
            console.error('Error fetching drivers:', error);
            setOperadores([]);
        }
    };

    useEffect(() => {
        findOperadores();
    }, []);

    const RehydrateAsset = () => 
    {
        const { values, setFieldValue } = useFormikContext();
        const alreadySet = useRef(false);

        useEffect(() => {
            if (alreadySet.current) return;
            if (!values.asset) return;

            const catalog =
                values.asset_type === 'TRACTOR'
                    ? tractorCatalog
                    : values.asset_type === 'CAJA'
                    ? cajaCatalog
                    : [];

            if (catalog.length === 0) return;

            setFieldValue('asset', values.asset);
            alreadySet.current = true;
        }, [tractorCatalog, cajaCatalog, values.asset_type]);

        return null;
    };

    const isEdit = Boolean(isEditing && carga);

    const editAssetType = isEdit ? normalizeAssetType(carga?.asset_type) : 'TRACTOR';

    const editCatalogReady =
    editAssetType === 'CAJA'
        ? cajaCatalog.length > 0
        : tractorCatalog.length > 0;

    const formReady = !isEdit || editCatalogReady;

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} maxWidth={false} >
            <DialogTitle>{isEditing ? 'Editar Carga' : 'Crear Carga'}</DialogTitle>
            <DialogContent>
                {formReady ? (
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit, values, touched, errors, setFieldValue }) => {
                
                    const catalogReady =
                    values.asset_type === 'CAJA'
                    ? cajaCatalog.length > 0
                    : tractorCatalog.length > 0;

                    return (
                        <>
                        <AssetTypeWatcher />
                        <RehydrateAsset />
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: isMobile
                                    ? '1fr' 
                                    : 'repeat(auto-fit, minmax(220px, 1fr))',
                                    gap: 2,
                                }}
                            >
                                {
                                    fields.map((field) => {

                                    let InputComponent;
                                    let extraProps = {};

                                    if (field.type === 'text') InputComponent = MyTextInput;
                                    else if (field.type === 'number') InputComponent = MyNumberInput;
                                    else if (field.type === 'datetime') InputComponent = MyDateTimePicker;
                                    else if (field.type === 'duration') InputComponent = MyDurationInput;
                                    else if (field.type === 'select') InputComponent = MySelectInput;
                                    else if (field.type === 'autocomplete') InputComponent = MyAutoComplete;
                                    else if (field.type === 'radio') InputComponent = MyRadioGroup;

                                    if (field.name === 'asset') 
                                    {
                                        const catalog =
                                        values.asset_type === 'TRACTOR'
                                            ? tractorCatalog
                                            : values.asset_type === 'CAJA'
                                            ? cajaCatalog
                                            : [];

                                        // Si el valor viene de carga y no está en el catálogo, lo agregamos temporalmente
                                        const initialAsset = carga?.asset;
                                        const assetToShow = values.asset || initialAsset;

                                        if (assetToShow && !catalog.some(a => a.value === assetToShow)) {
                                            extraProps.options = [...catalog, { value: assetToShow, label: assetToShow }];
                                        } else {
                                            extraProps.options = catalog;
                                        }

                                        extraProps.key = `asset-${values.asset_type}-${tractorCatalog.length}-${cajaCatalog.length}-${assetToShow}`;
                                    }

                                    if (field.name === 'driver') 
                                    {
                                        const catalog = operadores;

                                        const initialDriver = carga?.driver;
                                        const driverToShow = values.driver || initialDriver;

                                        if (driverToShow && !catalog.some(d => d.value === driverToShow)) {
                                            extraProps.options = [...catalog, { value: driverToShow, label: driverToShow }];
                                        } else {
                                            extraProps.options = catalog;
                                        }

                                        extraProps.key = `driver-reset-${resetCounter}-${driverToShow}`;
                                    }


                                    const hasError =
                                        touched[field.name] && Boolean(errors[field.name]);

                                    return (
                                        <Box
                                        key={field.name}
                                        sx={{
                                            gridColumn: isMobile
                                            ? 'span 1'
                                            : `span ${field.colSpan || 1}`,
                                            minWidth: 0,
                                        }}
                                        >
                                        {field.type === 'radio' ? (
                                            <InputComponent
                                                name={field.name}
                                                label={field.label}
                                                options={field.options || []}
                                            />
                                            ) : (
                                            <InputComponent
                                                key={extraProps.key} 
                                                fullWidth
                                                name={field.name}
                                                label={field.label}
                                                {...(field.type === 'select' || field.type === 'autocomplete'
                                                    ? { options: field.options }
                                                    : {})}
                                                {...extraProps}
                                                error={hasError}
                                                helperText={hasError && errors[field.name]}
                                            />
                                        )}


                                        {/* SOLO PARA FECHAS */}
                                        {field.type === 'datetime' && hasError && (
                                            <div
                                            style={{
                                                color: '#D3302F',
                                                fontSize: '12px',
                                                marginTop: 4,
                                            }}
                                            >
                                            {errors[field.name]}
                                            </div>
                                        )}
                                        </Box>
                                    );
                                    })}
                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" variant="contained" color="primary" disabled={!catalogReady || isSaving}>
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Box>
                        </Form>
                        </>
                    )}}
                </Formik>
                ) : (
                    <Box sx={{ padding: 4, textAlign: 'center' }}>
                        Cargando información...
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarColombia